export default __webpack_public_path__ + "static/media/lovelockdown-artworkinfo1.9d959df4.png";